import { CdkAutofill } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { RoleAccessPermissionDirective } from '@qaroni-core/directives/role-access-permission/role-access-permission.directive';
import { ComponentsModule } from '@qaroni-shared/components/components.module';
import { PipesModule } from '@qaroni-shared/pipes/pipes.module';
import { CheckWidgetComponent } from './check-widget/check-widget.component';
import { CompanyWidgetComponent } from './company-widget/company-widget.component';
import { CounterWidgetComponent } from './counter-widget/counter-widget.component';
import { MyPendingAbsencesWidgetComponent } from './my-pending-absences-widget/my-pending-absences-widget.component';
import { PendingAbsencesWidgetComponent } from './pending-absences-widget/pending-absences-widget.component';
import { PendingCheckRequestWidgetComponent } from './pending-check-request-widget/pending-check-request-widget.component';
import { ScoreboardWidgetComponent } from './scoreboard-widget/scoreboard-widget.component';
import { WorkplaceWidgetItemComponent } from './workplace-widget-item/workplace-widget-item.component';
import { WorkplacesWidgetComponent } from './workplaces-widget/workplaces-widget.component';

const widgets = [
  CheckWidgetComponent,
  CompanyWidgetComponent,
  CounterWidgetComponent,
  MyPendingAbsencesWidgetComponent,
  PendingAbsencesWidgetComponent,
  PendingCheckRequestWidgetComponent,
  ScoreboardWidgetComponent,
  WorkplacesWidgetComponent,
  WorkplaceWidgetItemComponent,
];

@NgModule({
  imports: [
    CdkAutofill,
    CommonModule,
    ComponentsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    PipesModule,
    RoleAccessPermissionDirective,
    RouterModule,
  ],
  declarations: [widgets],
  exports: [widgets],
})
export class WidgetsModule {}
